<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0" v-if="isapp">
      <h2 class="qrs-header-xl mt--0 mb--0">Medicines sick day guidance</h2>
    </pageHeader>
    <h1 v-if="!isapp" class="qrs-header-xl">Medicines sick day guidance</h1>

    <a
      @click="goBack()"
      class="govuk-back-link"
      role="button"
      aria-label="go back to the previous screen"
    >
      <strong>Previous</strong>
    </a>

    <h3>Privacy Statement</h3>

    <div>
      <p>
        This app collects information that you provide about the impact of your
        medicines and medicines review. This includes your name and date of
        birth and your Study ID if you are part of the i-SIMPATHY study.
      </p>
      <p>
        The information is stored on your mobile device and it is your
        responsibility to apply your own security measures to your device – e.g.
        password protection. If you choose the “Share” option within the app,
        this information is emailed securely to your chosen healthcare
        professional, who will review it and store it securely with your other
        health records. You have the right to request access at any time to see
        how this information is stored and can ask that the information is
        amended or removed. Your local practice will provide details of how you
        can request access to your health records.
      </p>
      <p>
        If you are participating in the i-SIMPATHY study, your pharmacist
        uploads the information you provide to a database to enable analysis of
        the impact of medicines review. Any information that could identify you
        personally will be excluded from the upload process, so that it is
        completely anonymous.
      </p>
      <p>
        If you are unable to complete the responses to the questions on the app
        yourself, your healthcare professional may use the app to enter the
        responses in consultation with you. If the healthcare professional is
        using their own device, they are required to delete the record of
        responses after emailing it to an NHS email address.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "privacyStatement",

  data() {
    return {
      isapp: this.$parent.isapp,
    };
  },

  methods: {
    goBack() {
      this.$parent.goTo(this.$Share);
    },
  },
};
</script>